import config from '@/config';

import { store, theme } from '@app/index';
import { Auth0Provider } from '@auth0/auth0-react';
import { AuthTokenProvider } from '@features/auth';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';

import { NetworkStatusBanner } from '@/components/feedback/NetworkStatusBanner';
import { AppErrorBoundary, RumPageTracker } from '@/components/observability';

import { SnackbarProvider } from './components/feedback/SnackbarProvider';
import { AppRoutes } from './routes';

/*
 * This is the main app component for the lingk-platform-ui application.
 * App component
 * @returns {React.ReactNode}
 */
const App = () => {
  return (
    <Auth0Provider
      domain={config.AUTH0_DOMAIN}
      clientId={config.AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: `${window.location.origin}/callback`,
        audience: config.AUTH0_AUDIENCE,
        scope: 'openid profile email offline_access',
      }}
      cacheLocation="localstorage"
      useRefreshTokens
    >
      <Provider store={store}>
        <AuthTokenProvider>
          <ThemeProvider theme={theme}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <CssBaseline />
              <SnackbarProvider>
                <NetworkStatusBanner />
                <BrowserRouter>
                  <RumPageTracker />
                  <AppErrorBoundary>
                    <AppRoutes />
                  </AppErrorBoundary>
                </BrowserRouter>
              </SnackbarProvider>
            </LocalizationProvider>
          </ThemeProvider>
        </AuthTokenProvider>
      </Provider>
    </Auth0Provider>
  );
};

export default App;
